// extracted by mini-css-extract-plugin
module.exports = {"check":"check_check__1JxO3","input":"check_input__365Of","box":"check_box__Eqt2x","box_checked":"check_box_checked__2Jv9-"};